import React from "react";
import { IoClose } from "react-icons/io5";
import { ImageComponent } from "../global/imageComponent";
import TeamLogo from "./TeamLogo";
import SportIcon from "./SportIcon";
import MatchStatus from "../lib/DateLive";
import { formatEventKickoff } from "../lib/dateFormat";
import MatchOddsGrid from "./MatchOddsGrid";
import { getMatchOddsGridDisplay } from "../../utility/matchOdds";
import { resolveSportIconUrl } from "../../services/sportGroupIcons";
import { Images } from "../../utility/image";

export default function FavRecentMatchCard({
  item,
  onOpen,
  onRemove,
  sportIconMaps,
}) {
  if (!item) return null;

  const oddsGrid = getMatchOddsGridDisplay(item);
  const sportIconUrl = resolveSportIconUrl(item?.sport_title, sportIconMaps);
  const kickoffLabel = formatEventKickoff(item?.commence_time, {
    includeTz: true,
  });

  return (
    <div
      className="matchTemplate fav-recent-match-card my-2 p-2 rounded-12"
      role="button"
      tabIndex={0}
      onClick={() => onOpen(item)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen(item);
        }
      }}
      aria-label={`Find ${item?.home_team} vs ${item?.away_team} in match list`}
      style={{ backgroundImage: `url(${Images.footbalGroundBg})` }}
    >
      <div className="fav-recent-card-status" aria-live="polite">
        <MatchStatus matchTime={`${item?.commence_time}`} />
        {kickoffLabel ? (
          <p className="fav-recent-card-kickoff fs12 mb-0">{kickoffLabel}</p>
        ) : null}
      </div>

      <div className="fav-recent-card-top">
        <div className="fav-recent-card-sport">
          <SportIcon
            sportName={item?.sport_title}
            iconUrl={sportIconUrl}
            className="fav-recent-card-sport-icon"
            alt=""
            size={18}
          />
          <p className="fav-recent-card-sport-label" title={item?.sport_title}>
            {item?.sport_title}
          </p>
        </div>
        <div className="fav-recent-card-top-end">
          {onRemove ? (
            <button
              type="button"
              className="fav-recent-card-remove-btn"
              aria-label={`Remove ${item?.home_team} vs ${item?.away_team} from recents`}
              onClick={(e) => {
                e.stopPropagation();
                onRemove(item);
              }}
            >
              <IoClose aria-hidden="true" />
            </button>
          ) : (
            <span className="fav-recent-card-top-spacer" aria-hidden="true" />
          )}
        </div>
      </div>

      <div className="fav-recent-card-matchup">
        <div className="fav-recent-card-side">
          <div className="fav-recent-card-logo-wrap">
            <TeamLogo
              teamName={item?.home_team}
              logoUrl={item?.home_team_logo}
              className="fav-recent-card-team-logo"
              size="md"
              alt={item?.home_team}
            />
          </div>
          <p className="fav-recent-card-team-name" title={item?.home_team}>
            {item?.home_team}
          </p>
        </div>

        <div className="fav-recent-card-vs" aria-hidden="true">
          <ImageComponent staticImgSrc="vsIcon" className="fav-recent-card-vs-icon" />
        </div>

        <div className="fav-recent-card-side">
          <div className="fav-recent-card-logo-wrap">
            <TeamLogo
              teamName={item?.away_team}
              logoUrl={item?.away_team_logo}
              className="fav-recent-card-team-logo"
              size="md"
              alt={item?.away_team}
            />
          </div>
          <p className="fav-recent-card-team-name" title={item?.away_team}>
            {item?.away_team}
          </p>
        </div>
      </div>

      {oddsGrid.hasOdds && <MatchOddsGrid grid={oddsGrid} />}
    </div>
  );
}
